import React, { useEffect, useRef } from 'react';

const AUTO_DELAY = 5000;
const Mscard = (props) => {
  const sceneRef = useRef(null);
  const autoTimerRef = useRef(null);

  useEffect(() => {
    const scene = sceneRef.current;
    if (!scene) return;

    const slides = Array.from(scene.querySelectorAll('.slide'));
    slides.forEach((el, i) => el.dataset.index = i);
    slides[0].dataset.current = 'true';

    const advanceSlide = () => {
      const current = scene.querySelector('[data-current="true"]');
      if (!current) return;
      const idx = Number(current.dataset.index);
      current.removeAttribute('data-current');

      const next = slides[(idx + 1) % slides.length];
      next.dataset.current = 'true';
    };

    scene.addEventListener('click', advanceSlide);
    scene.addEventListener('mouseenter', () => clearInterval(autoTimerRef.current));
    scene.addEventListener('mouseleave', () => {
      autoTimerRef.current = setInterval(advanceSlide, AUTO_DELAY);
    });

    autoTimerRef.current = setInterval(advanceSlide, AUTO_DELAY);

    return () => {
      clearInterval(autoTimerRef.current);
      scene.removeEventListener('click', advanceSlide);
    };
  }, []);

  const {card_url_1,card_url_2,card_url_3,card_url_4} = props.msofficeImage
  return (
    <div className="container scene img-container" id='sceneId' ref={sceneRef}>
      <div className='img-title'>MsOffice</div>

       <div>
        <div className="scene" >

  <div className="slide" data-current="true">
    <div className="image">
      <div className="background"></div>
    </div>

    <div className="image">
      <div className="-clip -rounded -outer">
        <div className="background"></div>
      </div>
    </div>

    <div className="image">
      <div className="-clip -rounded -inner image-fill">
      {/* <div className="-clip -rounded -inner" style={{'--bg-image1': `url(${ms1})`}}> */}
        <div className="background"></div>
        <img className='img slide-img' src={card_url_1} alt="MS Office course slide" />
      </div>
    </div>
  </div>
  
  <div className="slide">
    <div className="image">
      <div className="background"></div>
    </div>

    <div className="image">
      <div className="-clip -rounded -outer">
        <div className="background"></div>
      </div>
    </div>

    <div className="image">
      <div className="-clip -rounded -inner image-fill">
      {/* <div className="-clip -rounded -inner" style={{'--bg-image2': `url(${ms2})`}}> */}
        <div className="background"></div>
        <img className='img slide-img' src={card_url_2} alt="MS Office course slide" />
      </div>
    </div>
  </div>
  
  <div className="slide">
    <div className="image">
      <div className="background"></div>
    </div>

    <div className="image">
      <div className="-clip -rounded -outer">
        <div className="background"></div>
      </div>
    </div>

    <div className="image">
      <div className="-clip -rounded -inner image-fill">
      {/* <div className="-clip -rounded -inner" style={{'--bg-image3': `url(${ms3})`}}> */}
        <div className="background"></div>
        <img className='img slide-img' src={card_url_3} alt="MS Office course slide" />
      </div>
    </div>
  </div>
  
  <div className="slide">
    <div className="image">
      <div className="background"></div>
    </div>

    <div className="image">
      <div className="-clip -rounded -outer">
        <div className="background"></div>
      </div>
    </div>

    <div className="image">
      <div className="-clip -rounded -inner image-fill">
      {/* <div className="-clip -rounded -inner" style={{'--bg-image4': `url(${ms4})`}}> */}
        <div className="background"></div>
        <img className='img' src={card_url_4} alt="MS Office course slide" />
      </div>
    </div>
  </div>
  
  

</div>
    </div>
    </div>
  )
}

export default Mscard